import { render, staticRenderFns } from "./Univ.vue?vue&type=template&id=38569f59&scoped=true&"
import script from "./Univ.vue?vue&type=script&lang=js&"
export * from "./Univ.vue?vue&type=script&lang=js&"
import style0 from "./Univ.vue?vue&type=style&index=0&id=38569f59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38569f59",
  null
  
)

export default component.exports